import { Icon, cn } from "@sagot/ui";
import { useState } from "react";

/** Image box sizes (px) used by the launcher previews; the matching Tailwind size is fixed so no inline style is needed. */
const IMAGE_SIZE = { 28: "size-7", 36: "size-9", 40: "size-10" } as const;

export type LauncherMarkSize = keyof typeof IMAGE_SIZE;

interface LauncherMarkProps {
  /** The uploaded launcher icon; `null` = the chat-bubble glyph. */
  iconUrl: string | null;
  size: LauncherMarkSize;
  /** Glyph size classes, e.g. `size-5`. */
  glyphClassName?: string;
}

/**
 * What the widget draws inside the launcher: the uploaded icon (decorative, fixed box, circular,
 * `object-fit: cover`) or the chat-bubble glyph. A URL that fails to load falls back to the
 * glyph, exactly like the real launcher.
 */
export function LauncherMark({ iconUrl, size, glyphClassName }: LauncherMarkProps) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (iconUrl && failedUrl !== iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        width={size}
        height={size}
        data-launcher-icon=""
        className={cn("shrink-0 rounded-pill object-cover", IMAGE_SIZE[size])}
        onError={() => {
          setFailedUrl(iconUrl);
        }}
      />
    );
  }
  return <Icon name="message-circle" className={glyphClassName} />;
}
